import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useParams } from "react-router-dom";
import { GetBlog } from "./Components/Services";
import {
  ToTime,
  ToDateJalali,
  cutText,
  renderTimeMonth,
} from "../../Common/Function";
import Loading from "../../Common/Loading";
import RenderBasket from "../../Common/RenderBasket";
import { useSelector } from "react-redux";
import Mobile from "../../Common/Mobile";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/swiper-bundle.min.css";
// import "swiper/swiper.min.css";
import { useWeblog } from "./hooks/index";
import BlogCard from "../../Common/BlogCard";
import { webTemp, borderBottomTitle } from "../../../Utils/styles";
import Carousel from "react-material-ui-carousel";
function Single() {
  const basket = useSelector(state => state.basket);
  const { data, loading, getData } = useWeblog();
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Helmet>
        <title>مجله | نیکوتن </title>
        <meta
          name="description"
          content="نیکوتن جامع ترین سامانه معرفی، اطلاع رسانی و رزرو آنلاین استخر و پارک های آبی، باشگاه های بدنسازی، سالن های ورزشی و کلاس های ورزشی با تخفیف های ویژه"
        />
        <link rel="canonical" href={window.origin + `/weblog`} />
      </Helmet>
      <div id="weblog">
        <section className="weblog">
          <div className="container">
            <div className="row">
              <div
                className="col-12"
                style={{
                  ...webTemp,
                }}
              >
                <div
                  className="row title-row"
                  style={{
                    ...borderBottomTitle,
                  }}
                >
                  <div className="col title">
                    <h1 className="main-title">مقالات</h1>
                  </div>
                  <div className="col search-box">
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="d-flex align-items-center">
                        <Link to="/Blogs" className="btn btn-red all-blog ">
                          <img
                            src={
                              window.origin + "/WebSide/assets/images/magh.png"
                            }
                            alt="همه ملاقات"
                          />
                          <span>همه ملاقات</span>
                        </Link>
                        <div className=" input-search-box">
                          <input
                            className="border-0"
                            placeholder="جست و جو در مقالات"
                          />
                          <Link to="/blogs" className="btn btn-red ">
                            <img
                              src={
                                window.origin +
                                "/WebSide/assets/images/search.png"
                              }
                              alt="همه ملاقات"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {loading ? (
                  <Loading count={1} col={12} height={300} />
                ) : (
                  <>
                    {data && data.blog && (
                      <div className="row last-blog">
                        <div className="col-md-5 last-blog-content">
                          <div
                            className="d-flex flex-column justify-content-between"
                            style={{ height: "100%" }}
                          >
                            <div>
                              <div className="d-flex justify-content-between align-items-center">
                                <h3
                                  className="last-blog-title"
                                  style={{
                                    color: "#404040",
                                    fontWeight: "500",
                                  }}
                                >
                                  {data && data.blog && data.blog.title}
                                </h3>
                              </div>

                              <div>
                                <div
                                  className="content"
                                  style={{
                                    padding: "15px",
                                    textAlign: "justify",
                                    fontWeight: "400",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: cutText(
                                      data &&
                                        data.blog &&
                                        data.blog.description,
                                      600
                                    ),
                                  }}
                                />
                              </div>
                            </div>
                            <div>
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      color: "#B1B1B1",
                                    }}
                                  >
                                    <img
                                      src={
                                        window.origin +
                                        "/WebSide/assets/images/write.png"
                                      }
                                      style={{
                                        width: "10px",
                                        height: "10px",
                                        marginLeft: "5px",
                                      }}
                                      alt="همه ملاقات"
                                    />
                                    {data &&
                                      data.blog &&
                                      data.blog.authtor &&
                                      data.blog.authtor.fullname}
                                  </h6>
                                  <div className="d-flex justify-content-end">
                                    <div className="time-create">
                                      <h6
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "400",
                                          color: "#B1B1B1",
                                        }}
                                      >
                                        <img
                                          src={
                                            window.origin +
                                            "/WebSide/assets/images/time.png"
                                          }
                                          alt="همه ملاقات"
                                          style={{
                                            width: "10px",
                                            height: "10px",
                                            marginLeft: "5px",
                                          }}
                                        />
                                        {renderTimeMonth(
                                          data &&
                                            data.blog &&
                                            data.blog.created_at
                                        )}
                                      </h6>
                                      <h6
                                        style={{
                                          fontSize: "12px",
                                          color: "#B1B1B1",
                                          fontWeight: "400",
                                        }}
                                      >
                                        <img
                                          src={
                                            window.origin +
                                            "/WebSide/assets/images/sen.png"
                                          }
                                          style={{
                                            width: "10px",
                                            height: "10px",
                                            marginLeft: "5px",
                                          }}
                                          alt="تعداد بازدید‌"
                                        />
                                        تعداد بازدید‌ :{" "}
                                        {data && data.blog && data.blog.seens}
                                      </h6>
                                    </div>
                                  </div>
                                </div>

                                <Link
                                  to={`/Blogs/${
                                    data && data.blog && data.blog.slug
                                  }`}
                                  style={{
                                    borderRadius: "15px",
                                  }}
                                  className="btn btn-red continue"
                                >
                                  <span>ادامه مطلب</span>
                                  <img
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      marginRight: "10px",
                                    }}
                                    src={
                                      window.origin +
                                      "/WebSide/assets/images/down.png"
                                    }
                                    alt="ادامه مطلب"
                                  />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-7 last-blog-slider">
                          <Carousel
                            autoPlay={true}
                            indicators={true}
                            swipe={true}
                            cycleNavigation={true}
                            fullHeightHover={true}
                            animation={"fade"}
                          >
                            {data &&
                              data.blog &&
                              data.blog.images &&
                              data.blog.images.map((img, key) => {
                                return (
                                  <div
                                    style={{
                                      height: "400px",
                                      borderRadius: "20px",
                                      overflow: "hidden",
                                    }}
                                    key={key}
                                  >
                                    <img
                                      className="img-fluid "
                                      style={{
                                        objectFit: "cover",
                                        height: "400px",
                                        width: "100%",
                                      }}
                                      src={img}
                                    />
                                  </div>
                                );
                              })}
                          </Carousel>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="blog-single-page">
          <div className="container">
            <div className="row my-3">
              <div className="col-12 p-0">
                {loading ? (
                  <div className="row">
                    <Loading count={5} />
                  </div>
                ) : (
                  <div className="row align-items-center">
                    {data &&
                      data.blogCategries &&
                      data.blogCategries.map((element, key) => {
                        return (
                          <Link
                            className="col-6 col-md-2 mb-4 blog-category"
                            key={key}
                            to="/blogs"
                          >
                            <div
                              style={{
                                width: "160px",
                                height: "160px",
                                backgroundImage: `url(${element.photo})`,
                                backgroundPosition: "center",
                                backgroundSize: "cover",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexWrap: "nowrap",
                                cursor: "pointer",
                                position: "relative",
                                overflow: "hidden",
                                borderRadius: "8px",
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  position: "absolute",
                                  backgroundColor: "rgba(64, 64, 64,0.43)",
                                }}
                              ></div>
                              <h2
                                style={{
                                  textAlign: "center",
                                  color: "#fff",
                                  zIndex: 100,
                                }}
                              >
                                {element.name}
                              </h2>
                            </div>
                          </Link>
                        );
                      })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container ">
            <div className="row">
              <div
                className="col-12"
                style={{
                  backgroundColor: "#fff",
                  marginTop: "20px",
                  borderRadius: "15px",
                  border: "1px solid rgb(112, 112, 112,0.24)",
                  padding: "20px",
                }}
              >
                <div
                  className="row"
                  style={{
                    borderBottom: "1px solid rgb(112, 112, 112,0.24)",
                  }}
                >
                  <div className="col-12">
                    <h4
                      className="most-seen-title"
                      style={{ color: "#404040" }}
                    >
                      <img
                        src={window.origin + "/WebSide/assets/images/view.png"}
                        alt="مقالات پربازدید"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginLeft: "10px",
                        }}
                      />
                      مقالات پربازدید
                    </h4>
                  </div>
                </div>
                <div className="row mt-3">
                  {loading ? (
                    <Loading count={4} col={3} height={200} />
                  ) : (
                    <>
                      {data &&
                        data.blogs &&
                        data.blogs.map((blog, key) => {
                          return <BlogCard blog={blog} key={key} />;
                        })}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        <Mobile />
      </div>
    </>
  );
}

export default Single;
